
import React from 'react';
import AnimatedCard from '@/components/ui/AnimatedCard';
import { cn } from '@/lib/utils';

interface MaintenanceParameterProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  bgClass: string;
  status: string;
  lastUpdated: string;
  index: number;
}

const MaintenanceParameter: React.FC<MaintenanceParameterProps> = ({
  title,
  description,
  icon,
  bgClass,
  status,
  lastUpdated,
  index,
}) => {
  return (
    <AnimatedCard
      key={index}
      animation="fade-up"
      delay={100 * (index + 1)}
      className="border-none shadow-sm glass-panel"
    >
      <div className="p-4">
        <div className="flex items-start gap-3 mb-3">
          <div className={cn("rounded-full p-2", bgClass)}>
            {icon}
          </div>
          <div>
            <h3 className="font-medium text-sm">{title}</h3>
            <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
          </div>
        </div>
        <div className="flex justify-between items-center mt-3 pt-2 border-t border-gray-100 dark:border-gray-800">
          <span className={cn(
            "text-xs px-2 py-0.5 rounded-full",
            status === "Active" ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" : 
                                "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400"
          )}>
            {status}
          </span>
          <span className="text-xs text-muted-foreground">Updated: {lastUpdated}</span>
        </div>
      </div>
    </AnimatedCard>
  );
};

export default MaintenanceParameter;
